import { render, staticRenderFns } from "./BannedWatchers.vue?vue&type=template&id=63b18761&scoped=true&"
import script from "./BannedWatchers.vue?vue&type=script&lang=js&"
export * from "./BannedWatchers.vue?vue&type=script&lang=js&"
import style0 from "./BannedWatchers.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63b18761",
  null
  
)

export default component.exports